( function () {
	var relayoutTimer;

	function scheduleRelayout() {
		clearTimeout( relayoutTimer );
		relayoutTimer = setTimeout( layoutMasonry, 50 );
	}

	function layoutMasonry() {
		document.querySelectorAll( '[data-masonry]' ).forEach( function ( el ) {
			var container = el.querySelector( '.facetwp-template' ) || el;
			var items = Array.from( container.children ).filter( function ( item ) {
				return getComputedStyle( item ).display !== 'none';
			} );
			if ( ! items.length ) {
				return;
			}

			container.setAttribute( 'aria-busy', 'true' );

			var maxCols = parseInt( el.getAttribute( 'data-masonry' ) ) || 4;
			var gapPreset = el.getAttribute( 'data-masonry-gap' ) || 'default';
			var w = window.innerWidth;
			var cols = 1;
			var gapX = 28;
			var gapY;

			if ( gapPreset === 'compact' ) {
				if ( w >= 1280 ) {
					gapY = 48;
				} else if ( w >= 1024 ) {
					gapY = 32;
				} else if ( w >= 768 ) {
					gapY = 24;
				} else {
					gapY = 16;
				}
			} else {
				gapY = w >= 768 ? 64 : 36;
			}

			if ( w >= 1024 ) {
				cols = maxCols;
			} else if ( w >= 768 ) {
				cols = Math.min( 2, maxCols );
			}

			var containerWidth = container.offsetWidth;
			var colWidth = ( containerWidth - gapX * ( cols - 1 ) ) / cols;
			var colHeights = [];
			for ( var i = 0; i < cols; i++ ) {
				colHeights.push( 0 );
			}

			container.style.position = 'relative';

			items.forEach( function ( item ) {
				var minHeight = Math.min.apply( null, colHeights );
				var colIndex = colHeights.indexOf( minHeight );

				item.style.position = 'absolute';
				item.style.width = colWidth + 'px';
				item.style.left = colIndex * ( colWidth + gapX ) + 'px';
				item.style.top = colHeights[ colIndex ] + 'px';

				colHeights[ colIndex ] += item.offsetHeight + gapY;

				// Images that haven't loaded yet report a collapsed height, which
				// throws off the column heights above. Relayout once they arrive.
				item.querySelectorAll( 'img' ).forEach( function ( img ) {
					if ( ! img.complete ) {
						img.addEventListener( 'load', scheduleRelayout, { once: true } );
						img.addEventListener( 'error', scheduleRelayout, { once: true } );
					}
				} );
			} );

			var maxHeight = Math.max.apply( null, colHeights );
			container.style.height = ( maxHeight > 0 ? maxHeight - gapY : 0 ) + 'px';
			el.style.opacity = '1';
			container.style.opacity = '1';
			container.removeAttribute( 'aria-busy' );
		} );
	}

	var liveRegion;

	function announceResults() {
		var template = document.querySelector( '.facetwp-template' );
		if ( ! template ) {
			return;
		}
		var count = template.children.length;
		var message = count === 0
			? 'No results found.'
			: count + ( count === 1 ? ' result' : ' results' ) + ' shown.';

		if ( ! liveRegion ) {
			liveRegion = document.createElement( 'div' );
			liveRegion.setAttribute( 'aria-live', 'polite' );
			liveRegion.setAttribute( 'aria-atomic', 'true' );
			liveRegion.setAttribute( 'role', 'status' );
			liveRegion.className = 'sr-only';
			document.body.appendChild( liveRegion );
		}
		liveRegion.textContent = message;
	}

	layoutMasonry();
	document.addEventListener( 'facetwp-loaded', function () {
		layoutMasonry();
		announceResults();
	} );

	var resizeTimer;
	window.addEventListener( 'resize', function () {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( layoutMasonry, 150 );
	} );
} )();

// Registered on alpine:init (rather than assigned directly on window.Components)
// because the parent theme's components.js runs after this file and resets
// `window.Components = {}`, which would otherwise wipe this out.
( function () {
	document.addEventListener( 'alpine:init', function () {
		window.Components = window.Components || {};
		window.Components.searchModal = function searchModal() {
			return {
				__type: 'searchModal',
				open: false,
				init() {
					this.$watch( 'open', function ( open ) {
						document.body.classList.toggle( 'modal-active', open );
					} );
				},
				toggle() {
					this.open = ! this.open;
				},
				close() {
					this.open = false;
				},
			};
		};

		// Single-artwork hero image lightbox/zoom. State + focus-trap wiring
		// lives here (per the searchModal convention above); the actual
		// wheel/drag/keyboard pan-zoom math lives in the block's own
		// content-single-artwork.js, which listens for the
		// 'artwork-lightbox:open' / 'artwork-lightbox:close' events dispatched
		// below to activate/reset itself.
		window.Components.artworkLightbox = function artworkLightbox() {
			return {
				__type: 'artworkLightbox',
				isOpen: false,
				triggerEl: null,
				init() {
					this.$watch( 'isOpen', ( isOpen ) => {
						document.body.classList.toggle( 'modal-active', isOpen );
						if ( isOpen ) {
							this.$dispatch( 'artwork-lightbox:open' );
						} else {
							this.$dispatch( 'artwork-lightbox:close' );
							if ( this.triggerEl ) {
								this.triggerEl.focus();
							}
						}
					} );
				},
				open( triggerEl ) {
					this.triggerEl = triggerEl;
					// Note: can't use this.$el here — $el is scoped to whichever
					// element's directive is currently evaluating (the trigger
					// button), not the x-data root, so a querySelector from it
					// would miss the dialog's img entirely. $refs is scoped to
					// the whole component regardless of which element invoked us.
					var img = this.$refs.lightboxImage;
					if ( img ) {
						img.src = triggerEl.getAttribute( 'data-lightbox-src' ) || '';
						img.alt = triggerEl.getAttribute( 'data-lightbox-alt' ) || '';
					}
					this.isOpen = true;
				},
				close() {
					this.isOpen = false;
				},
			};
		};
	} );
} )();
